import { render, staticRenderFns } from "./ReadinessOrgOccupationTag.vue?vue&type=template&id=bb4f69fc&scoped=true"
import script from "./ReadinessOrgOccupationTag.vue?vue&type=script&setup=true&lang=js"
export * from "./ReadinessOrgOccupationTag.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReadinessOrgOccupationTag.vue?vue&type=style&index=0&id=bb4f69fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f69fc",
  null
  
)

export default component.exports